import { EscHotKeyIcon } from '@modules/common/components/HotKeyIcons';
import { validateEmail } from '@modules/common/utils';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Stack } from '@mui/material';

interface SubscribeDrawerFooterProps {
  onCancel: () => void;
  onSave: () => void;
  isSaveRequestInProgress: boolean;
  isSaveDisabled: boolean;
  selectedEmails: string[];
  setEmailErrorMessage: (message: string) => void;
  isSubscribed: boolean;
  isRemoveRequestInProgress: boolean;
  onRemoveButtonClick: () => void;
}

const SubscribeDrawerFooter = ({
  onCancel,
  onSave,
  isSaveRequestInProgress,
  isSaveDisabled,
  selectedEmails,
  setEmailErrorMessage,
  isSubscribed,
  isRemoveRequestInProgress,
  onRemoveButtonClick,
}: SubscribeDrawerFooterProps) => {
  const saveSubscription = () => {
    const hasInvalidEmail = selectedEmails.find(
      (email) => !validateEmail(email).isValid,
    );
    if (hasInvalidEmail) {
      setEmailErrorMessage('One of the provided emails is invalid.');
      return;
    }
    onSave();
  };

  return (
    <Box
      sx={{
        py: 2,
        px: 4,
        borderRadius: 0,
        borderTop: '1px solid',
        borderColor: 'divider',
        position: 'sticky',
        bottom: 0,
        zIndex: 1050,
        backgroundColor: 'misc.drawer.background',
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box>
          {isSubscribed && (
            <LoadingButton
              variant="outlined"
              color="error"
              onClick={onRemoveButtonClick}
              loading={isRemoveRequestInProgress}
            >
              Unsubscribe
            </LoadingButton>
          )}
        </Box>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Button
            variant="outlined"
            onClick={onCancel}
            endIcon={<EscHotKeyIcon />}
          >
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            onClick={saveSubscription}
            loading={isSaveRequestInProgress}
            disabled={isSaveDisabled}
          >
            {isSubscribed ? 'Update' : 'Subscribe'}
          </LoadingButton>
        </Stack>
      </Stack>
    </Box>
  );
};

export default SubscribeDrawerFooter;
